import { useSyncExternalStore } from 'react';
import type { GameId, Scores } from '@/lib/types';

type Bucket = { score: number; raw: Record<string, number> };
const KEY = 'apex.scores.v1';

function read(): Scores {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch { /* ignore */ }
  return {} as Scores;
}

let state: Scores = read();
const listeners = new Set<() => void>();

function notify() {
  try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* ignore */ }
  listeners.forEach((l) => l());
}

export function setScore(game: GameId, bucket: Bucket) {
  state = { ...state, [game]: bucket };
  notify();
}

export function resetScores() {
  state = {} as Scores;
  notify();
}

export function getScores(): Scores {
  return state;
}

export function useScores(): Scores {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => state,
    () => state,
  );
}
